import { render, staticRenderFns } from "./activity-qr-sign-register.vue?vue&type=template&id=5613a102&scoped=true&"
import script from "./activity-qr-sign-register.vue?vue&type=script&lang=js&"
export * from "./activity-qr-sign-register.vue?vue&type=script&lang=js&"
import style0 from "./activity-qr-sign-register.vue?vue&type=style&index=0&id=5613a102&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5613a102",
  null
  
)

export default component.exports